import {combineReducers} from "redux";
import {appReducers} from "./reducers/app.reducers";

export default combineReducers({
	app: appReducers,
});
